import type { ICloud } from '../model/ICloud'
import type { IData } from '../model/IData'
import { expectDefined } from './expectDefined'
import { getCouples } from './getCouples'
import { getParentCouple } from './getParentCouple'

export function markClouds(data: IData) {
	let cloudId = 1
	let cloud: ICloud
	data.clouds = []
	const seen = new Set<string>()
	for (const person of Object.values(data.personsById)) {
		if (person.cloudId == null) {
			data.clouds.push(
				(cloud = {
					id: cloudId++,
					personIds: [],
				}),
			)
		}
		markRelatives(data, person.id, cloud!, seen)
	}
	data.clouds.sort((a, b) => b.personIds.length - a.personIds.length)
	for (const person of Object.values(data.personsById)) {
		person.cloudId =
			data.clouds.findIndex((cloud) => cloud.id === person.cloudId) + 1
	}
	for (const cloud of data.clouds) {
		cloud.id = data.clouds.indexOf(cloud) + 1
	}
}

function markRelatives(
	data: IData,
	personId: string | null | undefined,
	cloud: ICloud,
	seen: Set<string>,
) {
	if (!personId || seen.has(personId)) return
	const person = expectDefined(data.personsById[personId])
	person.cloudId = cloud.id
	cloud.personIds.push(person.id)
	seen.add(personId)
	const parentCouple = getParentCouple(data, personId)
	if (parentCouple) {
		if (parentCouple.femaleId || parentCouple.maleId) {
			markRelatives(data, parentCouple.maleId, cloud, seen)
			markRelatives(data, parentCouple.femaleId, cloud, seen)
		} else if (parentCouple.childIds) {
			for (const siblingId of parentCouple.childIds) {
				if (siblingId === personId) continue
				markRelatives(data, siblingId, cloud, seen)
			}
		}
	}
	for (const couple of getCouples(data, personId)) {
		markRelatives(data, couple.maleId, cloud, seen)
		markRelatives(data, couple.femaleId, cloud, seen)
		if (couple.childIds) {
			for (const childId of couple.childIds) {
				markRelatives(data, childId, cloud, seen)
			}
		}
	}
}
